import React from 'react';
import { Input } from 'antd';

const TriggerWindowFields = ({ formData, updateField }) => {
  return (
    <>
      <div className='step-section-title'>Trigger Window</div>
      <div className='step-form-hint'>
        This rule fires this many days from the attribute below — e.g. 15 days from welcome_redeemed_flag = true.
      </div>

      <div className='d-flex d-flex-row gap-16 alignCenter'>
        <div className='w-50'>
          <div className='step-form-label'>Validity Period (days)</div>
          <Input
            value={formData?.triggerWindowDays || ''}
            onChange={(e) => updateField('triggerWindowDays', e.target.value)}
            placeholder='Input'
            className='Input-border InputText'
          />
        </div>
      </div>
    </>
  );
};

export default TriggerWindowFields;
